




































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { getAvailableTimeSlots } from '@/api';
import { AppointmentType, AvailableTimeSlot, Member, ScheduleApptDetails, Slot, Timezone } from '@/types';
import { formatDateFormat, formatInTimeZone, getUtcDate, hideLoader, showLoader } from '@/util';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'TimeSlots',
  data () {
    return {
      defaultTimeSlot: {},
      selectedTimeZone: {} as Timezone,
      selectedTmeSlot: {} as Slot,
      selectedTeamMember: {} as Member,
      timeSlots: [] as AvailableTimeSlot[],
      errorMessage: '',
      EventType
    }
  },
  props: {
    appointmentType: {
      type: Object as PropType<AppointmentType>,
      required: true
    },
    appointmentDetails: {
      type: Object as PropType<ScheduleApptDetails>,
      required: true
    },
    timeZones: {
      type: Array as PropType<Timezone[]>,
      required: true
    },
    apptScheduledWith: {
      type: String,
      required: true
    }
  },
  async mounted () {
    showLoader();
    await this.fetchTimeSlots();
    if (this.appointmentDetails.timeSlot?.start && this.appointmentDetails.teamMember.length) {
      const userId = this.appointmentDetails.teamMember.length === 1 ? this.appointmentDetails.teamMember[0].userId : this.apptScheduledWith ? +this.apptScheduledWith : null;
      if (userId && this.appointmentDetails.date === formatDateFormat(this.appointmentDetails.timeSlot.start, 'YYYY-MM-DD')) {
        this.selectedTeamMember = this.getMemberData(userId);
        this.setDefaultTimeSlot(userId);
      }
      this.selectedTimeZone = this.appointmentDetails.timeZone;
    }
    hideLoader();
  },
  computed: {
    ...mapGetters(['selectedJobDetails']),
    formatDate (): string[] {
      const dateStr = this.appointmentDetails.date + 'T00:00:00';
      return [new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(new Date(dateStr)),
        new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' }).format(new Date(dateStr))];
    },
    isDataSelected (): boolean {
      return !!this.selectedTmeSlot.end && !!this.selectedTimeZone.name && !this.errorMessage;
    }
  },
  methods: {
    async fetchTimeSlots () {
      await Promise.all(
        this.appointmentDetails.teamMember.map(async (member: Member) => {
          const start = formatDateFormat(this.appointmentDetails.date, 'YYYY-MM-DD') === formatDateFormat(new Date(), 'YYYY-MM-DD') ? getUtcDate(new Date()) : getUtcDate(new Date(this.appointmentDetails.date));
          const date1 = new Date(this.appointmentDetails.date);
          date1.setDate(date1.getDate() + 1);
          const endDate = date1.toISOString().split('T')[0];
          const end = `${endDate}T00:00:00Z`;
          const params = {
            buffer: this.appointmentType.buffer,
            type: this.appointmentType.stage.toLowerCase(),
            areaId: this.selectedJobDetails.areaId
          };
          const response = await getAvailableTimeSlots(member.userId, this.appointmentType.duration, start, end, '0', params);
          this.timeSlots.push({
            userId: member.userId,
            slots: response.availability?.availableSlots || []
          });
        })
      );
    },
    onTimeSlotSelected (slot: Slot, memberId: number) {
      if (this.selectedTmeSlot.start === slot.start && this.selectedTeamMember.userId === memberId) {
        this.selectedTmeSlot = {} as Slot;
      } else {
        this.selectedTmeSlot = slot;
        this.selectedTeamMember = this.getMemberData(memberId);
      }
    },
    setTime () {
      if (this.selectedTmeSlot) {
        this.$emit(EventType.SET_APPOINTMENT_TIME, {
          timeSlot: this.selectedTmeSlot,
          timeZone: this.selectedTimeZone,
          teamMember: this.selectedTeamMember
        });
      } else {
        this.errorMessage = 'Please select a time slot';
      }
    },
    formatSlot (slot: Date) {
      return formatInTimeZone(slot, 'h:mm a', this.selectedTimeZone.value);
    },
    getMemberData (memberId: number) {
      return this.appointmentDetails.teamMember.find(member => member.userId === memberId) || {} as Member;
    },
    getTeamMemberName (memberId: number) {
      const data = this.getMemberData(memberId);
      return `${data.firstName} ${data.lastName}`;
    },
    setDefaultTimeSlot (userId: number) {
      const modifyApptWithSameMember = this.apptScheduledWith && this.apptScheduledWith === this.selectedTeamMember.userId?.toString();
      const idx = this.timeSlots.findIndex((slot) => slot.userId === userId);
      const slot = this.timeSlots[idx].slots.find(slot => slot.start === this.appointmentDetails.timeSlot.start && slot.end === this.appointmentDetails.timeSlot.end);
      if (slot) {
        this.onTimeSlotSelected(slot, userId);
      } else if (modifyApptWithSameMember) {
        this.timeSlots[idx].slots.push(this.appointmentDetails.timeSlot);
        this.onTimeSlotSelected(this.appointmentDetails.timeSlot, userId);
      }
    },
    isSelectedSlot (slot: Slot, userId: number) {
      return slot.start === this.selectedTmeSlot?.start && slot.end === this.selectedTmeSlot?.end && userId === this.selectedTeamMember.userId;
    }
  }
});
